module.exports = __webpack_public_path__ + "static/media/welcomedotoverlay.54937322.png";